// Finance
// ----------------------
// Strange Animals

$(function() {
    //Finance Popout - Controller

    var $financeContent = $('#finance');
    var $landContent = $('#land');
    var $homeContent = $('#home');
    var $financeBtn = $('#finance-btn');
    var $landBtn = $('#land-btn');
    var $homeBtn = $('#home-btn');

    //Controller Functions

    function openFinance() {
        if (!$financeContent.hasClass('active') && !$financeBtn.hasClass('active')) {
            $financeContent.addClass('active');
            $financeContent.siblings().removeClass('active');
            $financeBtn.addClass('active');
            $financeBtn.siblings().removeClass('active');
        }
    }

    function openLand() {
        if (!$landContent.hasClass('active') && !$landBtn.hasClass('active')) {
            $landContent.addClass('active');
            $landContent.siblings().removeClass('active');
            $landBtn.addClass('active');
            $landBtn.siblings().removeClass('active');
        }
    }

    function openHome() {
        if (!$homeContent.hasClass('active') && !$homeBtn.hasClass('active')) {
            $homeContent.addClass('active');
            $homeContent.siblings().removeClass('active');
            $homeBtn.addClass('active');
            $homeBtn.siblings().removeClass('active');
        }
    }

    //Event Handlers

    $financeBtn.unbind('click').click(function(event) {
        event.preventDefault();
        openFinance();
    });

    $landBtn.unbind('click').click(function(event) {
        event.preventDefault();
        openLand();
    });

    $homeBtn.unbind('click').click(function(event) {
        event.preventDefault();
        openHome();
    });

    let financeForm = $('#TotemForm_FinanceApplicationForm');
    $('.subfield').hide();
    financeForm.change(function(e) {
        let target = e.target;
        let parent = target.parentElement;
        if (target.type === 'radio' && parent.nodeName === 'LABEL') {
            let selected = $('label.checked input[name="' + target.name + '"]').parent();
            if (selected.length) {
                selected.removeClass('checked');
            }
            $(parent).addClass('checked');

            if (target.name === 'IsRenting') {
                if ($(target).val() === 'Yes') {
                    $('.rent').show();
                } else {
                    $('.rent').hide();
                }
            }
        }
    });

    let resizeTimer;
    $(window).on('resize', function(e) {
        if ($('#page-finance').length) {
            $('.cover-slider').css('position', 'relative');
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                $('.cover-slider').css('position', 'fixed');
            }, 250);
        }
    });
});

// Adjusting CSS on load as slick slider breaks if you set position before it is loaded
window.onload = function() {
    if ($('#page-finance').length) {
        $('.cover-slider').css('position', 'fixed');
    }
};
